import React from 'react';
import { useState } from 'react';
import { withRouter } from 'react-router-dom';

const ViewWorkout = ({ match }) => {
  const [w] = useState(match && match.params ? match.params.w : null);

  if (!w) {
    return null;
  }

  return (
    <div style={{  width: '100vw', height: '100vh' }}>
      <iframe
        width="100%"
        height="100%"
        src={`https://www.youtube.com/embed/${w}?playsinline=1`}
        frameBorder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        style={{ position: 'absolute', top: 0, left: 0 }}
      />
    </div>
  );
};

export default withRouter(ViewWorkout);
